<template>
    <div class="get_yinbi_item_container" v-for="item in items" :key="item.id"  @click="toCartPage(item.id)">
        <div class="get_yinbi_item_left">
            <div class="get_yinbi_item_text_a">{{ item.name }}</div>
            <div class="get_yinbi_item_text_b">{{ getStatusText(item.status) }}</div>
        </div>

        <div class="get_yinbi_item_img">
            <img :src="require(`@/assets/${item.imgUrl}`)" />
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

import { useRouter } from 'vue-router';

  const router = useRouter();

defineProps({
    items: {
        type: Array,
        required: true,
        default: () => []
    }
});

function toCartPage(id) {
    // router.push({ name: 'FenXiangGuan' });
    const url = router.resolve({ name: 'Cart' }).href + '?id=' + id;
    window.location.href = url;
  }

const getStatusText = (status) => {
    return status === 1 ? '已解锁' : '未解锁';
};
</script>

<style scoped>
.get_yinbi_item_container{
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: center;
    background: #ededed;
    border-radius: 0.3rem;
    width: 98%;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    margin-bottom: 0.4rem;
    
  }

  .get_yinbi_item_left{
    display: flex;
    flex: 3;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    margin: 0.1rem 0.2rem;

    
    
  }

  .get_yinbi_item_img{
    display: flex;
    flex: 2;
    
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
    justify-content: center;
    
  }
  .get_yinbi_item_img img{
    width: 40%;
  }

  .get_yinbi_item_text_a{
    font-size: 0.7rem;
    margin-bottom: 0.1rem;
    
  }

  .get_yinbi_item_text_b{
    font-size: 0.4rem;
    color: #848488;
    margin-top: 0.1rem;
    
  }

  .get_yinbi_item_text_c{
    font-size: 0.5rem;
    
    margin-top: 0.3rem;
    padding: 0.1rem 1rem;
    border: 0.04rem solid #1296db;
    border-radius: 0.3rem;
    margin-bottom: 0.1rem;
    margin-top: 0.3rem;
  }

  .get_yingbi_intro{
    display: flex;
    flex-direction: column;
    
    justify-content: left;

    margin-top: 0.5rem;
  }


  .get_yingbi_intro_item{
    display: flex;
    flex-direction: column;

    margin-bottom: 0.5rem;
    
    
    margin-left: 0.3rem;
    
  }

    
    
  .get_yingbi_intro_item_title{
    font-size: 0.4rem;
    
    margin-bottom: 0.1rem;
    color: #000000;
    text-align: left;
    
  }
  .get_yingbi_intro_item_main_body{
    font-size: 0.4rem;
    color:#848488;
    margin-bottom: 0.1rem;
    
    
    text-align: left;
  }

</style>